import React from 'react';
import {Text, StyleSheet, Platform} from 'react-native';

const GradientText = ({
  text,
  colors = ['#4ECDC4', '#44A08D'],
  style = {},
  locations = [0, 1],
  start = {x: 0, y: 0},
  end = {x: 1, y: 1}
}) => {
  const getGradientAngle = () => {
    const dx = end.x - start.x;
    const dy = end.y - start.y;
    const angle = Math.atan2(dy, dx) * (180 / Math.PI);
    return angle + 90;
  };

  const createGradientString = () => {
    const angle = getGradientAngle();
    const colorStops = colors.map((color, index) => {
      const location = locations[index] !== undefined ? locations[index] : index / (colors.length - 1);
      return `${color} ${location * 100}%`;
    }).join(', ');
    return `linear-gradient(${angle}deg, ${colorStops})`;
  };

  const webGradientStyle = {
    backgroundImage: createGradientString(),
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text',
    textFillColor: 'transparent',
  }

  return (
    <Text
      style={[
        styles.gradientText,
        style,
        webGradientStyle
      ]}
    >
      {text}
    </Text>
  );
};

const styles = StyleSheet.create({
  gradientText: {
    backgroundColor: 'transparent',
  },
});

export default GradientText;

